import React, { memo, Fragment } from "react";
import { Dropdown, Badge } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper";
import useRedirect from "../../../../../../../components/custom-hooks/use-redirect";
import { findIcon } from "../../../../../../dashboard/icons";
import { getFormatedDate } from "../../../../../../../common/utils/utils";
import { useDispatch } from "react-redux";
import { updateProject } from "../../../../../../../store/project/project.action";
import * as dayjs from "dayjs";

const ProjectCard = memo(
  ({
    project_id,
    title,
    tags,
    projectType,
    channel_logo,
    projectTypeId,
    projectTypeCode,
    startDate,
    endDate,
    updateDate,
    projectStatus,
  }) => {
    const dispatch = useDispatch();
    const { redirectTo } = useRedirect();
    const onManageClick = (projectTypeCode) => {
      dispatch(
        updateProject({
          project_id,
          title,
          tags,
          projectType,
          projectTypeCode,
          updateDate,
          channel_logo,
          start_date: startDate,
          end_date: endDate,
        })
      );
      switch (projectTypeCode) {
        case "brand_ads":
          redirectTo(`brand-ads/summary/${project_id}`);
          break;
        case "doctube_channel":
          redirectTo(`project/channels`);
          break;
        case "sponsored_content":
          redirectTo(`sponsored-content/summary/${project_id}`);
          break;
        case "events":
          redirectTo(`events/summary/${project_id}`);
          break;
        case "emsl":
          redirectTo(`emsl/summary/engaged-hcps/${project_id}`);
          break;
        case "clirnet_channel":
          redirectTo(`sponsored-community/dashboard/${project_id}`);
          break;
        default:
          break;
      }
    };

    const handleSelect = (eventKey) => {
      redirectTo(`workspace/edit-project/${project_id}`, {
        eventKey: eventKey || {},
      });
    };

    const userActions = [
      {
        label: "Edit Project",
        onClick: () => onManageClick(projectTypeCode),
      },
    ];

    function generateData(date) {
      const isEndDatePassed = dayjs(date).isBefore(dayjs());
      if (isEndDatePassed) {
        return getFormatedDate(date);
      } else {
        return getFormatedDate(dayjs().subtract(1, "day"));
      }
    }

    let project_icon = findIcon("Channel Icon", "dual-tone", 16);

    switch (projectTypeCode) {
      case "brand_ads":
        project_icon = findIcon("start-up", "solid", 16);
        break;
      case "sponsored_content":
        project_icon = findIcon("bulb", "solid", 16);
        break;
      case "events":
        project_icon = findIcon("video-chat", "solid", 16);
        break;
      case "emsl":
        project_icon = findIcon("magnet", "solid", 16);
        break;
    }

    const disabledProjectStyles = {
      opacity: "opacity-50 ",
      badge: "soft-secondary ",
      editBtn: "text-black ",
      swiperText: "text-secondary ",
    };

    return (
      <Fragment>
        <div className={`card flex-grow-1`} to="#">
          <div className="card-header d-flex align-items-center justify-content-between">
            {projectType && (
              <Badge
                bg={`${
                  projectStatus === 2
                    ? disabledProjectStyles.badge
                    : "soft-primary"
                }`}
                className={`d-flex gap-1 align-items-center ${
                  projectStatus === 2 ? disabledProjectStyles.opacity : ""
                }`}
                onClick={() => {
                  if (projectStatus === 2) return;
                  onManageClick(projectTypeCode);
                }}
              >
                <span className="fill-primary">{project_icon}</span>
                <span className="fs-7 fw-semibold">{projectType}</span>
              </Badge>
            )}

            <div className="d-flex align-items-center gap-sm-2 gap-1">
              {/* {projectStatus === 2 && (
                <Badge
                  bg="light"
                  className={`rounded-pill text-nowrap w-auto text-black opacity-50`}
                >
                  Disabled
                </Badge>
              )} */}

              {updateDate && (
                <span className="fs-7 d-flex align-items-center fw-medium text-black-50">
                  <span className="me-1">
                    {findIcon("date_update", "outline", 14)}
                  </span>
                  {generateData(updateDate)}
                </span>
              )}

              <div className="ms-auto">
                <Dropdown onSelect={handleSelect}>
                  <Dropdown.Toggle
                    role="button"
                    bsPrefix="btn"
                    variant="transparent"
                    size="sm"
                    className={`btn-icon rounded-pill ${
                      projectStatus === 2 ? disabledProjectStyles.editBtn : ""
                    }`}
                  >
                    <svg
                      width="5"
                      viewBox="0 0 5 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.49927 2.50444V2.49544"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.49927 7.50438V7.49538"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.49927 12.5044V12.4954"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="dropdown-menu-end rounded-3 z-3"
                    aria-labelledby="news-dropdown"
                  >
                    {userActions?.length > 0 &&
                      userActions.map((option, index) => (
                        <Dropdown.Item
                          key={index}
                          eventKey={index + 1}
                          onClick={option.onClick}
                        >
                          {option.label}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div
            className={`card-body ${
              projectStatus === 2
                ? disabledProjectStyles.opacity
                : "cursor-pointer"
            }`}
            onClick={() => {
              if (projectStatus === 2) return;
              onManageClick(projectTypeCode);
            }}
          >
            <div className="d-flex flex-row gap-3 align-items-center">
              <div className="avatar-45 border border-opacity-25 rounded-circle overflow-hidden">
                <img
                  className="img-thumbnail shadow-none p-1 border-0 rounded-0"
                  src={channel_logo}
                  alt="Channel Logo"
                ></img>
              </div>
              <div className="d-flex flex-column text-break">
                {title && (
                  <h6
                    className="text-capitalize m-0 text-black one-line-clamp"
                    title={title}
                  >
                    {title}
                  </h6>
                )}
                {startDate && (
                  <span className="fs-7 d-flex justify-content-start align-items-center text-black fw-medium">
                    <b className="fw-normal text-black-50">Start Date</b>&nbsp;
                    {getFormatedDate(startDate)}
                  </span>
                )}
              </div>
            </div>
            {tags && tags?.length > 0 && (
              <>
                <div className="border-top mb-2 mt-3 mx-n4"></div>
                <Swiper
                  as="ul"
                  className=""
                  slidesPerView={"auto"}
                  spaceBetween={5}
                  freeMode={true}
                  modules={[Mousewheel]}
                  mousewheel={true}
                >
                  <SwiperSlide className="w-auto">
                    {projectStatus === 2 && (
                      <Badge
                        bg="light"
                        className={`rounded-pill text-nowrap w-auto text-black`}
                      >
                        Disabled
                      </Badge>
                    )}
                  </SwiperSlide>
                  {tags &&
                    tags.length > 0 &&
                    tags.map((tag, index) => (
                      <SwiperSlide className="w-auto" key={index}>
                        <Badge
                          bg="light"
                          className={`rounded-pill text-nowrap ${
                            projectStatus === 2
                              ? disabledProjectStyles.swiperText
                              : "text-primary"
                          }`}
                        >
                          {tag.label}
                        </Badge>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
);

ProjectCard.displayName = "ProjectCard";
export default ProjectCard;
